import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["g_translation"]),
    getTextByKey() {
      return (key) => {
        return (
          this.g_translation?.[key]?.[
            "locale_" + this.$vuetify.locale.current
          ] || ""
        );
      };
    },
  },
};
